import React, { FC, ReactChild } from 'react'
import classnames from 'classnames'
import Container from '@material-ui/core/Container'
import withSharedStyles from '../../hooks/withSharedStyles'

const Section: FC<{
  center?: boolean,
  padding?: boolean,
  paddingHalf?: boolean,
  paddingDouble?: boolean,
  className?: string,
}> = ({
  center = false,
  padding = false,
  paddingHalf = false,
  paddingDouble = false,
  children,
  className,
}) => {
  const sharedClasses = withSharedStyles()
  return (
    <Container
      className={
        classnames(sharedClasses.containerWrapper, className, {
          [sharedClasses.paddingContainer]: padding && !paddingHalf && !paddingDouble,
          [sharedClasses.paddingHalfContainer]: !padding && paddingHalf && !paddingDouble,
          [sharedClasses.paddingDoubleContainer]: !padding && !paddingHalf && paddingDouble,
          [sharedClasses.centerContainer]: center,
        })
      }
    >
      <div className={ sharedClasses.container }>
        { children as ReactChild }
      </div>
    </Container>
  )
}

export default Section